import PageHeader from "../components/PageHeader";
import SEOMeta from "../components/SEOMeta";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <SEOMeta
        title="Privacy Policy"
        description="Privacy Policy for Dugavu Ventures — a global consulting firm specialising in corporate strategy, minerals, mining, and oil and gas advisory services."
        url="/privacy"
      />
      <PageHeader
        eyebrow="Legal"
        title="Privacy Policy."
        lede="How Dugavu Ventures Ltd handles personal information collected through this website and in the course of an engagement."
        testid="privacy-header"
      />
      <section className="py-20 md:py-28">
        <div className="max-w-[1240px] mx-auto px-6 md:px-10 lg:px-14">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-3">
              <div className="eyebrow">Last updated</div>
              <p className="mt-2 text-[14px] text-slate font-mono">December 2025</p>
            </div>
            <div className="md:col-span-9 max-w-3xl space-y-6 text-charcoal text-[16px] leading-relaxed">
              <h2 className="font-serif text-2xl text-ink">Information we collect</h2>
              <p>We collect personal information when you contact us by email or in the course of providing advisory services. The information you choose to share is the information we hold.</p>

              <h2 className="font-serif text-2xl text-ink mt-8">How we use information</h2>
              <p>Personal information is used solely to respond to enquiries, deliver engagements, and meet our legal and regulatory obligations. We do not sell or rent personal information.</p>

              <h2 className="font-serif text-2xl text-ink mt-8">Confidentiality</h2>
              <p>Information shared in the course of an engagement is held under contract and within the engagement team. It is returned or destroyed at the end of the mandate, save where retention is required by law.</p>

              <h2 className="font-serif text-2xl text-ink mt-8">Your rights</h2>
              <p>You have the right to ask what personal information we hold about you, and to request its correction or deletion where that is consistent with our legal obligations.</p>

              <h2 className="font-serif text-2xl text-ink mt-8">Contact</h2>
              <p>Privacy enquiries should be addressed to <a href="mailto:info@dugavuventures.com" className="text-oxblood link-rule">info@dugavuventures.com</a>.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
